import React from 'react'

function IconCard({icono , description}) {
    return (
        <div className="flex flex-col items-center w-52 bg-white p-5 gap-5 rounded-lg rounded-tl-none shadow-[-10px_10px_0px_0px_#0D2334] border-solid border-4 border-primario transform hover:-translate-y-2 transition duration-300">
            <i class={icono}></i>
            <p className='text-xl font-bold text-primario'>{description}</p>
        </div>
    )
}

export default IconCard